:host {
  display: block;
}

.biel-message__sources {
  margin-top: 10px;
}

.biel-message__sources-toggle {
  display: flex;
  align-items: center;
  background-color: var(--biel-message-source-bg-color);
  border: none;
  padding: 5px 10px;
  cursor: pointer;
  font-size: var(--biel-message-source-font-size);
  border-radius: 6px;
  margin-bottom: 0;
  color: var(--biel-message-source-text-color);
}

.biel-message__sources-toggle:hover {
  background-color: var(--biel-message-source-bg-hover-color);
}

.biel-message__sources-toggle span {
  margin-right: 5px;
}

.biel-message__sources-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 0;
  padding: 0;
  margin-top: 8px;
}

.biel-message__source-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid var(--biel-message-source-bg-color);
  border-radius: 8px;
  text-decoration: none;
  color: var(--biel-message-source-text-color);
  font-size: var(--biel-message-source-font-size);
  transition: background-color 0.2s ease;
  overflow: hidden;
}

.biel-message__source-card:hover {
  background-color: var(--biel-message-source-bg-hover-color);
}

.biel-message__source-card svg {
  flex-shrink: 0;
  opacity: 0.6;
}

.biel-message__source-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
